<div class="app-es-poa-sidebar">
  <div class="app-es-poa-sidebar__header-close" (click)="close.emit()">×</div>

  <div class="app-es-poa-sidebar__content poa-sidebar-content">
    <div class="app-es-poa-sidebar__content__body">
      <company-power-attorney
        [companyId]="company?.id"
        [identifierQualifier]="company?.identifierQualifier"
        [isShowSubheader]="false"
        [isShowDescription]="true"
        [isTablet]="false"
        [isRegistrationApproved]="true"
        [allowManualBeforeApproval]="true"
        [enablePoaSelection]="true"
        [isLoadingCompanyPoa]="isLoadingCompanyPoa"
        [selectedPoaVariant]="selectedPoaVariant"
        [poaPurchaseReturnUrl]="poaPurchaseReturnUrl"
        [isCompactLayout]="true"
        [company]="company"
        [canRemovePoa]="false"
        (uploadDocument)="onManualPoaUpload($event)"
        (updateDocumentState)="onManualPoaStateUpdate($event)"
        (selectedPoaVariantChange)="onSelectedPoaVariantChange($event)"
        (poaAvailabilityChange)="onPoaAvailabilityChange($event)"
        (requestSaveBeforeSign)="onRequestSaveBeforeSign()"
      ></company-power-attorney>
    </div>

    <div class="app-es-poa-sidebar__content__footer">
      <button [disabled]="isSaveDisabled" type="button" class="btn btn-primary btn-square mb-5" (click)="onSave()">
        {{ "BUTTON.SAVE" | translate }}
      </button>
    </div>
  </div>
</div>
